import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import config from '@/amplifyconfiguration.json';

export const amplifyClient = () => {
  Amplify.configure(config);
  const client = generateClient();

  return client;
};
